import { useState } from "react";
import { Phone, Instagram, Menu, X, Calculator } from "lucide-react";
import { COMPANY } from "@/data/services";

const NAV = [
  { href: "#top", label: "Inicio", id: "nav-inicio" },
  { href: "#servicios", label: "Servicios", id: "nav-servicios" },
  { href: "#calculadora", label: "Calculadora", id: "nav-calculadora" },
  { href: "#como-trabajamos", label: "Cómo trabajamos", id: "nav-como" },
  { href: "#faq", label: "FAQ", id: "nav-faq" },
  { href: "#contacto", label: "Contacto", id: "nav-contacto" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200"
    >
      <div className="container mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 shrink-0" data-testid="logo-link">
          <img
            src={COMPANY.logo}
            alt={COMPANY.name}
            className="w-11 h-11 rounded-lg object-contain bg-white border border-slate-200 shadow-sm p-0.5"
            data-testid="header-logo-img"
          />
          <div className="leading-tight">
            <div className="font-display font-semibold text-[15px] text-slate-900">Multiservicios PS 24</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#004B87] font-semibold">S.L.U. · Valencia</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7 text-sm text-slate-600">
          {NAV.map(n => (
            <a key={n.id} href={n.href} className="hover:text-[#004B87] transition-colors" data-testid={n.id}>
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={`https://instagram.com/${COMPANY.instagram}`}
            target="_blank" rel="noreferrer"
            className="hidden sm:inline-flex w-9 h-9 items-center justify-center rounded-lg border border-slate-200 text-slate-600 hover:text-[#004B87] hover:border-[#004B87] transition-colors"
            data-testid="header-instagram"
            aria-label="Instagram"
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            href={`tel:+34${COMPANY.whatsapp}`}
            className="hidden sm:inline-flex items-center gap-2 h-9 px-3 rounded-lg border border-slate-200 text-slate-700 text-sm font-medium hover:border-[#004B87] hover:text-[#004B87] transition-colors"
            data-testid="header-call-btn"
          >
            <Phone className="w-3.5 h-3.5" />
            {COMPANY.whatsapp}
          </a>
          <a
            href="#calculadora"
            className="inline-flex items-center gap-2 h-9 px-3.5 rounded-lg bg-[#004B87] text-white text-sm font-medium hover:bg-[#003A6A] transition-colors"
            data-testid="header-cta-calc"
          >
            <Calculator className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Calcular presupuesto</span>
            <span className="sm:hidden">Calcular</span>
          </a>
          <a
            href="/pro"
            className="hidden md:inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-emerald-500/40 text-emerald-700 text-xs font-semibold uppercase tracking-wider hover:bg-emerald-50 transition-colors"
            data-testid="header-pro-link"
            title="Acceso a Budget Calc Pro · Modo profesional"
          >
            Modo Pro
          </a>
          <button
            type="button"
            onClick={() => setOpen(o => !o)}
            className="lg:hidden w-9 h-9 grid place-items-center rounded-lg border border-slate-200 text-slate-700"
            data-testid="header-menu-toggle"
            aria-label="Menú"
          >
            {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white" data-testid="mobile-nav">
          <nav className="container mx-auto px-4 py-3 grid grid-cols-2 gap-1 text-sm">
            {NAV.map(n => (
              <a
                key={n.id}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-2.5 px-3 rounded-lg hover:bg-slate-50 text-slate-700"
                data-testid={`mobile-${n.id}`}
              >
                {n.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
